import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import MemberStore from '../../stores/MemberStore';

const ReactPropTypes = PropTypes;
const webroot = get(globals, 'webroot', '/');

class MemberName extends React.Component {
  static propTypes = {
    memberId: ReactPropTypes.string,
    disable: ReactPropTypes.bool,
  };

  static defaultProps = {
    memberId: null,
    disable: false,
    linkClass: '',
    custom_link: false,
  };

  state = {
    member: MemberStore.get(this.props.memberId),
  };

  onClickDisabled = (e) => {
    e.preventDefault();
  };

  render() {
    const member = this.state.member;
    const custom_link = this.props.custom_link;

    // disable, empty, deleted vai admin
    if (this.props.disable || !member || ['deleted', 'admin'].indexOf(member.status) !== -1) {
      return (
        <a href="#" className={this.props.linkClass} onClick={this.onClickDisabled}>
          {this.props.children}
        </a>
      );
    }

    let memberUrl = `${webroot}member/${this.props.memberId}`;

    if (custom_link != false) {
      memberUrl = custom_link;
    }

    return (
      <a href={memberUrl} data-target="#content" className={this.props.linkClass}>
        {this.props.children}
      </a>
    );
  }
}

module.exports = MemberName;
